import { Button, TEOLoader, InputText } from '@teo/components';
import {
  Plus,
  Search,
  CrossFilled,
  InformationFilled,
} from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useGet } from '@/query';
import { PaginationAnything } from '@/components/DataTable/PaginationAnything';
import { SelectSearchDropdown } from '../../SelectSearchDropdown';
import TextWithTooltip from '@/pages/Protected/Manage/Competencies/TextWithTooltip';

function CompetenceIcon({ className = '' }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.27943 10.1855C4.30574 10.1842 4.3319 10.1897 4.3556 10.2012C4.37935 10.2128 4.39999 10.2303 4.41517 10.252C4.99206 11.0582 5.73702 11.7299 6.59779 12.2217C7.45851 12.7134 8.41508 13.014 9.40248 13.1016C9.60193 13.1191 9.80381 13.1279 10.0079 13.1279C10.1759 13.1279 10.3431 13.1216 10.5079 13.1094C10.5348 13.1076 10.5618 13.1134 10.5861 13.125C10.6104 13.1367 10.6312 13.1546 10.6466 13.1768C10.6619 13.1988 10.6714 13.2243 10.674 13.251C10.6764 13.2779 10.6714 13.3054 10.6603 13.3301L8.07826 19C7.98181 19.2112 7.74182 19.362 7.5099 19.375C7.40116 19.3733 7.29434 19.3437 7.20033 19.2891C7.10632 19.2344 7.02805 19.1562 6.97279 19.0625L5.46205 16.5361C5.40695 16.4456 5.32875 16.3716 5.23549 16.3213C5.14196 16.271 5.03596 16.2461 4.92982 16.25H1.88295C1.77181 16.2498 1.66268 16.221 1.56556 16.167C1.46832 16.1129 1.38604 16.0349 1.32728 15.9404C1.2146 15.7499 1.23114 15.5155 1.33802 15.3203L4.15052 10.2656C4.1634 10.2425 4.18275 10.223 4.20521 10.209C4.22762 10.1951 4.2531 10.1869 4.27943 10.1855ZM15.7355 10.1826C15.7617 10.184 15.7874 10.1922 15.8097 10.2061C15.8319 10.2198 15.8505 10.239 15.8634 10.2617L18.6574 15.3076C18.7059 15.39 18.7367 15.482 18.7462 15.5771C18.7557 15.6723 18.7443 15.769 18.713 15.8594C18.624 16.114 18.4265 16.2499 18.1661 16.25H15.089C14.8684 16.2488 14.6638 16.3458 14.5509 16.5352L13.0451 19.0576C12.9905 19.1518 12.9131 19.2306 12.8195 19.2861C12.7258 19.3417 12.6188 19.3723 12.5099 19.375C12.2784 19.3619 12.0391 19.2073 11.9435 18.9961L10.7609 16.3955C10.7424 16.3551 10.7326 16.311 10.7326 16.2666C10.7326 16.2221 10.7424 16.1781 10.7609 16.1377L12.2003 12.9697C12.268 12.8224 12.3903 12.7069 12.5411 12.6475C13.7698 12.1577 14.8313 11.3246 15.5997 10.248C15.615 10.2267 15.6358 10.2096 15.6593 10.1982C15.6829 10.1869 15.7093 10.1813 15.7355 10.1826ZM10.0099 0.625C13.1119 0.625 15.6349 3.14844 15.6349 6.25C15.6349 9.35156 13.1111 11.875 10.0099 11.875C6.90876 11.875 4.3849 9.35193 4.3849 6.25C4.3849 3.14807 6.90759 0.625042 10.0099 0.625ZM11.2062 3.36328C10.6353 3.12679 10.0066 3.06407 9.40052 3.18457C8.79433 3.30515 8.23698 3.603 7.79994 4.04004C7.36292 4.47707 7.06602 5.03445 6.94545 5.64062C6.82492 6.24676 6.88668 6.87533 7.12318 7.44629C7.35972 8.0171 7.75982 8.50535 8.27357 8.84863C8.78745 9.192 9.39186 9.37498 10.0099 9.375C10.8384 9.37397 11.6331 9.04479 12.2189 8.45898C12.8047 7.87316 13.1339 7.07848 13.1349 6.25C13.1349 5.63193 12.9519 5.02758 12.6085 4.51367C12.2652 3.9999 11.777 3.59982 11.2062 3.36328ZM10.0099 4.375C11.0456 4.375 11.8849 5.21447 11.8849 6.25C11.8849 7.28553 11.0456 8.125 10.0099 8.125C8.97419 8.12496 8.1349 7.28551 8.1349 6.25C8.1349 5.21449 8.97419 4.37504 10.0099 4.375Z"
        fill="#231F20"
      />
    </svg>
  );
}

const AddCompetence = ({
  title,
  text,
  info_text,
  setDeleteList,
  setAddList,
  addList,
  listCompetencies,
  setIsOpenAddCompetencies,
}) => {
  const { t } = useTranslation();

  const hendleDelete = (item) => {
    const existsAdd = addList?.find(
      (el) => el?.competenceId === item.competenceId
    );
    if (existsAdd) {
      setAddList((prev) =>
        prev?.filter((el) => el?.competenceId !== item.competenceId)
      );
    } else {
      setDeleteList((prev) => [...prev, item]);
    }
  };

  return (
    <div className="-ml-6 -mr-6 flex flex-col overflow-y-auto">
      {listCompetencies?.length > 0 && (
        <div className="px-6 pb-6">
          <div className="flex w-full items-center gap-1 rounded-lg bg-tint-blue-light p-5">
            <InformationFilled className="h-6 w-6 text-tint-blue" />
            <p
              className="text-sm text-[#004795]"
              dangerouslySetInnerHTML={{
                __html:
                  `<b>${listCompetencies?.length} ${
                    listCompetencies?.length > 1
                      ? t(
                          'pages.create_edit_course.competence_add.competencies'
                        )
                      : t('pages.create_edit_course.competence_add.competence')
                  } </b>` + t(info_text),
              }}
            ></p>
          </div>
        </div>
      )}
      <div className="flex flex-col border-b px-6 pb-6">
        <h3 className="mb-2 text-base">{t(title)}</h3>
        <p className="text-sm text-grey-06">{t(text)}</p>
      </div>
      <div className="flex flex-col gap-2 px-6 pt-6 pb-2">
        {listCompetencies?.length > 0 && (
          <>
            <h4>
              {listCompetencies?.length}{' '}
              {listCompetencies?.length > 1
                ? t('pages.create_edit_course.competence_add.competencies')
                : t('pages.create_edit_course.competence_add.competence')}
              {t('pages.create_edit_course.competence_add.added')}
            </h4>
            <div className="flex flex-col gap-2">
              {listCompetencies?.map((comp) => {
                return (
                  <div
                    key={comp?.id}
                    className="flex items-center gap-2 rounded-md border px-4 py-3"
                  >
                    <CompetenceIcon className="min-w-[20px]" />

                    <p>{comp?.name}</p>

                    <div className="ml-auto flex min-w-max items-center gap-2">
                      {comp?.competenceCategoryId && (
                        <>
                          {comp?.code && (
                            <div className="rounded-[4px] bg-grey-02 px-2 py-0.5 text-xs text-grey-06">
                              {comp?.code}
                            </div>
                          )}
                          <p className="flex min-w-max items-center text-sm text-grey-08">
                            <span
                              style={{
                                backgroundColor:
                                  comp?.competenceCategoryColorCode,
                              }}
                              className={`mr-2 h-2 w-2 min-w-2 rounded-full`}
                            ></span>
                            {comp?.competenceCategoryName}
                          </p>
                        </>
                      )}
                      <div>
                        <Button
                          className="!px-2"
                          variant="ghost"
                          onClick={() => {
                            hendleDelete(comp);
                          }}
                        >
                          <CrossFilled className="h-4 w-4 text-grey-06" />
                        </Button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
        <div>
          <Button
            variant="outline"
            onClick={() => setIsOpenAddCompetencies(true)}
          >
            {t('pages.manage_competencies.add_competencies')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddCompetence;
